import { toast } from "@/hooks/use-toast";
import {
  useUpdateTemplateFactory,
  UseUpdateTemplateType,
} from "@/hooks/notesTemplates/useUpdateTemplateFactory";
import { t } from "i18next";
import { useEffect } from "react";
import { CardContentTemplateGenerated } from "./CardContentTemplateGenerated";
import type { NoteTemplate } from "@/common/types/notesTemplates";

interface Props {
  note: NoteTemplate;
  refresh: () => void;
}

export const CardContentNote = (props: Props): React.ReactNode => {
  const { updateTemplate, result, loading, error } = useUpdateTemplateFactory(
    UseUpdateTemplateType.NOTE
  );

  const handleSave = async (value: string): Promise<void> => {
    await updateTemplate({ result: value, id: props.note.id });
  };

  useEffect(() => {
    if (!loading) {
      if (error) {
        toast({
          variant: "error",
          title: t("visit.messages.updateFailed"),
        });
      }
      if (result) {
        toast({
          variant: "success",
          title: t("visit.messages.updateSuccessful"),
        });
      }
    }
  }, [error, loading, result]);

  return (
    <CardContentTemplateGenerated
      file={props.note}
      loading={loading}
      onSave={handleSave}
    />
  );
};
